import { InputHTMLAttributes } from 'react';
import styled from '@emotion/styled';
import { uiTheme as t } from './theme';

/**
 * Primitivo: casilla de verificación con el verde de marca.
 *
 * Sigue siendo un `<input type="checkbox">` nativo —teclado, lectores de
 * pantalla y estado indeterminado incluidos—; lo único que cambia es
 * `accent-color`, que sustituye el azul por omisión del navegador sin tener
 * que redibujar el control.
 */
const Input = styled.input({
  accentColor: t.color.primary,
  width: 16,
  height: 16,
  cursor: 'pointer',
  '&:disabled': { cursor: 'not-allowed', opacity: 0.5 },
});

// `type` va después del spread: un componente que se llama Checkbox no debería
// poder acabar siendo otra cosa por descuido de quien lo usa.
const Checkbox = (props: Omit<InputHTMLAttributes<HTMLInputElement>, 'type'>) => <Input {...props} type="checkbox" />;

export default Checkbox;
